import { Card } from '@mui/material';
import React from 'react';
import "./Sidebar.css"
import VerticalTabs from './VerticalTabs';


function Sidebar() {
  return (
  <>
  <VerticalTabs />
  </>
    )
}

export default Sidebar;
